// extracted by mini-css-extract-plugin
module.exports = {"container":"upload_container__9teZw"};